<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start"><ion-menu-button></ion-menu-button></ion-buttons>
    <ion-title>Laptop-kölcsönzés</ion-title>
    <ion-buttons slot="end">
      <ion-button style="background:white;border-radius:5px" color="primary" [strong]="true"
                  shape="round" (click)="ujKiadas()">
        <ion-icon slot="start" name="add"></ion-icon>Új kiadás
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <!-- A késés a legfontosabb információ: ez az egyetlen ok, amiért egyáltalán
       érdemes vezetni a nyilvántartást. Ezért a lista fölött, nem benne. -->
  <ion-card *ngIf="osszesito.kesik" color="danger" class="lk-riaszt">
    <ion-card-content>
      <b>{{ osszesito.kesik }}</b> gép késik — a vállalt visszahozatal napja elmúlt.
      <ion-button size="small" fill="clear" color="light" (click)="szuresValt('kesik')">Mutasd</ion-button>
    </ion-card-content>
  </ion-card>

  <ion-card>
    <ion-card-content>
      <div class="lk-vezerlok">
        <ion-segment [value]="szures" (ionChange)="szuresValt($event.detail.value)">
          <ion-segment-button value="kint"><ion-label>Kint ({{ osszesito.kint }})</ion-label></ion-segment-button>
          <ion-segment-button value="kesik"><ion-label>Késik ({{ osszesito.kesik }})</ion-label></ion-segment-button>
          <ion-segment-button value="visszahozva"><ion-label>Visszahozva</ion-label></ion-segment-button>
          <ion-segment-button value="mind"><ion-label>Mind ({{ osszesito.osszes }})</ion-label></ion-segment-button>
        </ion-segment>
        <ion-searchbar [(ngModel)]="kereses" (ionInput)="betolt()" [debounce]="300"
                       placeholder="Sorozatszám vagy név…" show-clear-button="focus"></ion-searchbar>
      </div>

      <div *ngIf="toltodik" class="lk-uzenet"><ion-spinner name="dots"></ion-spinner> Betöltés…</div>
      <div *ngIf="!toltodik && !tetelek.length" class="lk-uzenet">
        Ebben a nézetben nincs bejegyzés.
      </div>

      <div class="lk-tabla-burok" *ngIf="!toltodik && tetelek.length">
        <table class="lk-tabla">
          <thead>
            <tr>
              <th>Sorozatszám</th><th>Kinél van</th><th>Kiadva</th>
              <th>Visszahozza</th><th>Állapot</th><th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let t of tetelek" [class.kesik]="t.kesik" [class.kesz]="t.visszahozva">
              <td><b>{{ t.sorozatszam }}</b>
                <div class="lk-megj" *ngIf="t.megjegyzes">{{ t.megjegyzes }}</div>
              </td>
              <td>
                {{ t.atvevo_nev || t.atvevo }}
                <div class="lk-halvany">{{ tipusNev(t.atvevo_tipus) }} · {{ t.atvevo }}</div>
              </td>
              <td>{{ t.kiadva }}</td>
              <td>
                {{ t.varhato_vissza || '—' }}
                <div class="lk-halvany" *ngIf="t.visszahozva">visszahozva: {{ t.visszahozva }}</div>
              </td>
              <td>
                <ion-chip [color]="allapotSzin(t)" class="lk-chip">{{ allapotSzoveg(t) }}</ion-chip>
              </td>
              <td class="lk-muveletek">
                <ion-button size="small" fill="outline" color="success" *ngIf="!t.visszahozva"
                            (click)="vissza(t)">Visszavétel</ion-button>
                <ion-button size="small" fill="clear" color="medium" *ngIf="t.visszahozva"
                            (click)="visszaMegse(t)">Mégsem hozta vissza</ion-button>
                <ion-button size="small" fill="clear" (click)="szerkeszt(t)">
                  <ion-icon slot="icon-only" name="create-outline"></ion-icon>
                </ion-button>
                <ion-button size="small" fill="clear" color="danger" (click)="torol(t)">
                  <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
                </ion-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ion-card-content>
  </ion-card>

  <!-- Kiadás / szerkesztés -->
  <ion-modal [isOpen]="modalNyitva" (didDismiss)="modalZar()" class="nagy">
    <ng-template>
      <ion-header>
        <ion-toolbar color="primary">
          <ion-buttons slot="start"><ion-button (click)="modalZar()">Mégse</ion-button></ion-buttons>
          <ion-title>{{ szerkesztettId ? 'Kölcsönzés módosítása' : 'Laptop kiadása' }}</ion-title>
          <ion-buttons slot="end">
            <ion-button style="background:white;border-radius:5px" color="primary" [strong]="true"
                        shape="round" [disabled]="!menthet || fut" (click)="ment()">Mentés</ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding">
        <ion-grid>
          <ion-row>
            <ion-col size="12" size-md="6">
              <ion-input label="Sorozatszám *" label-placement="stacked" fill="outline"
                         [(ngModel)]="urlap.sorozatszam" placeholder="a gép alján / a BIOS-ban">
                <ion-icon slot="start" name="barcode-outline"></ion-icon>
              </ion-input>
            </ion-col>
            <ion-col size="6" size-md="3">
              <ion-input type="date" label="Kiadva *" label-placement="stacked" fill="outline"
                         [(ngModel)]="urlap.kiadva"></ion-input>
            </ion-col>
            <ion-col size="6" size-md="3">
              <ion-input type="date" label="Visszahozza" label-placement="stacked" fill="outline"
                         [(ngModel)]="urlap.varhato_vissza"></ion-input>
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col size="12">
              <h2 class="lk-cim">Kinek adod ki?</h2>
              <div class="lk-valasztott" *ngIf="urlap.atvevo">
                <b>{{ urlap.atvevo_nev || urlap.atvevo }}</b>
                <span>{{ tipusNev(urlap.atvevo_tipus) }} · {{ urlap.atvevo }}</span>
              </div>
              <!-- Kereshető és névsorba rendezett: több száz fős listában a görgetés
                   használhatatlan, és a rossz sor kiválasztása itt tárgyi eszközt
                   könyvel rossz emberre. -->
              <div class="lk-valaszto">
                <ion-searchbar [(ngModel)]="szemelySzuro" placeholder="Név vagy azonosító…"
                               show-clear-button="focus"></ion-searchbar>
                <ion-segment [(ngModel)]="szemelyTipus">
                  <ion-segment-button value="mind"><ion-label>Mind</ion-label></ion-segment-button>
                  <ion-segment-button value="dolgozo"><ion-label>Dolgozó</ion-label></ion-segment-button>
                  <ion-segment-button value="tanulo"><ion-label>Tanuló</ion-label></ion-segment-button>
                </ion-segment>
                <ion-list class="lk-szemelyek" lines="full">
                  <ion-item *ngFor="let sz of szurtSzemelyek" button="true"
                            [color]="urlap.atvevo === sz.azonosito ? 'primary' : ''"
                            (click)="szemelyValaszt(sz)">
                    <ion-label>
                      <h3>{{ sz.nev }}</h3>
                      <p>{{ tipusNev(sz.tipus) }}<span *ngIf="sz.reszlet"> · {{ sz.reszlet }}</span></p>
                    </ion-label>
                  </ion-item>
                  <ion-item *ngIf="!szurtSzemelyek.length">
                    <ion-label class="lk-halvany">Nincs találat.</ion-label>
                  </ion-item>
                </ion-list>
              </div>
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col size="12">
              <ion-textarea label="Megjegyzés" label-placement="stacked" fill="outline"
                            [autoGrow]="true" rows="2" [(ngModel)]="urlap.megjegyzes"
                            placeholder="töltő, táska, sérülés…"></ion-textarea>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-content>
    </ng-template>
  </ion-modal>
</ion-content>
